import helpers from '../util/helpers';

export default {
  init() {
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $(document).on('click', '.heading-wrapper .dropdown-menu', function (e) {
      e.stopPropagation();
    });

    const copyButtons = $('.copy-to-clipboard-button');
    if (copyButtons.length) {
      copyButtons.each(function() {
        const thisCopyButton = $(this);
        const defaultIcon = thisCopyButton.find('.copy-to-clipboard-default-icon');
        const successIcon = thisCopyButton.find('.copy-to-clipboard-success-icon');

        thisCopyButton.on('click', function(e) {
          e.preventDefault();

          const _this = $(this);
          const text = _this.data('text');

          defaultIcon.hide();
          successIcon.show();
          helpers.copyToClipboard(text);

          setTimeout(function() {
            defaultIcon.show();
            successIcon.hide();
          }, 3000);
        });
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptStories.js